<template lang="pug">
  .video-red-packet-skeleton-container
    SkeletonItem(className='video-red-packet-skeleton-title')
    .video-red-packet-skeleton-list
      SkeletonItem(className='video-red-packet-skeleton-list-item')
      SkeletonItem(className='video-red-packet-skeleton-list-item')
      SkeletonItem(className='video-red-packet-skeleton-list-item')
      SkeletonItem(className='video-red-packet-skeleton-list-item')
      SkeletonItem(className='video-red-packet-skeleton-list-item')
      SkeletonItem(className='video-red-packet-skeleton-list-item')
      SkeletonItem(className='video-red-packet-skeleton-list-item')
      SkeletonItem(className='video-red-packet-skeleton-list-item')
      SkeletonItem(className='video-red-packet-skeleton-list-item')
</template>

<script>
import SkeletonItem from '@/components/skeleton-item';

export default {
  name: 'VideoRedPacketSkeleton',
  components: {
    SkeletonItem,
  },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.video-red-packet-skeleton-container {
  overflow: hidden;
  padding: 0.12rem 0 0.14rem 0.12rem;
  width: 100%;
  background-color: #fff;
  border-radius: 0.12rem;
  box-sizing: border-box;

  .video-red-packet-skeleton-title {
    width: 1.38rem;
    height: 0.22rem;
  }

  .video-red-packet-skeleton-list {
    display: flex;
    flex-wrap: nowrap;
    margin-top: 0.12rem;
  }

  .video-red-packet-skeleton-list-item {
    flex-shrink: 0;
    margin-right: 0.1rem;
    width: 0.48rem;
    height: 0.55rem;
  }
}
</style>
